<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue';
import Icon from '../miscellaneous/Icon.vue';
import SidebarNavigationItems from './SidebarNavigationItems.vue';

const region = computed(() => window.meta?.region_configuration?.region || 'de');

const viewportWidth = ref(window.innerWidth);

onMounted(() => {
    const handleResize = () => {
        viewportWidth.value = window.innerWidth;
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    onUnmounted(() => {
        window.removeEventListener('resize', handleResize);
    });
});

const isSmallerViewpoint = computed(() => viewportWidth.value <= 1279);
</script>

<template>
    <div class="bg-blue-dark hidden xl:flex flex-col justify-between text-white transition-all ease-in-out duration-500 max-h-screen h-screen relative z-20">
        <div class="absolute top-0 right-0 transform p-2 cursor-pointer" @click="$store.commit('settings/toggleBackendSidebar', { name: 'backend_sidebar' })">
            <Icon
                type="Toggle"
                viewBox="0 0 13 13"
                width="15"
                height="15"
                :class="$store.getters['settings/getBackendSidebarStateByName']('backend_sidebar') ? '' : 'rotate-180'"
                class="fill-current"
            />
        </div>

        <div class="flex justify-center items-center px-8 pt-8 pb-4">
            <router-link to="/" class="block w-[110px] shrink-0 cursor-pointer">
                <!-- Usual Logo-->
                <img
                    v-if="region === 'de' && $store.getters['settings/getBackendSidebarStateByName']('backend_sidebar')"
                    class="w-full h-10"
                    :src="$asset('/hkcm/images/logo-on-dark-background.svg', 'public')"
                    alt="HKCM Logo"
                    title="HKCM Logo"
                />
                <!-- Closed Sidebar Logo-->
                <img
                    v-if="!$store.getters['settings/getBackendSidebarStateByName']('backend_sidebar')"
                    class="w-full h-[44px]"
                    :src="$asset('/hkcm/images/logo-small-on-dark-background.svg', 'public')"
                    alt="HKCM Logo"
                    title="HKCM Logo"
                />
                <!-- GLOBAL Logo-->
                <img
                    v-if="region !== 'de' && $store.getters['settings/getBackendSidebarStateByName']('backend_sidebar')"
                    class="w-full h-auto"
                    :src="$asset('/hkcm/images/logo-hkcm-global_2_light.svg', 'public')"
                    alt="HKCM Logo"
                    title="HKCM Logo"
                />
            </router-link>
        </div>

        <div v-if="!isSmallerViewpoint" class="h-full flex items-center">
            <div class="w-full">
                <SidebarNavigationItems />

                <div class="px-4">
                    <router-link
                        to="/dashboard/howto#faqs"
                        :title="$t('FAQs')"
                        exact-active-class="bg-blue"
                        :class="$store.getters['settings/getBackendSidebarStateByName']('backend_sidebar') ? 'pl-8' : 'justify-center py-2'"
                        class="text-white flex gap-3 items-center w-full px-4 py-2 mb-4 rounded-xl hover:scale-105 duration-300"
                    >
                        <i class="fi fi-rr-info flex align-middle text-white"></i>
                        <span v-if="$store.getters['settings/getBackendSidebarStateByName']('backend_sidebar')" class="whitespace-nowrap truncate">{{ $t('FAQs') }}</span>
                    </router-link>
                </div>
            </div>
        </div>

        <div :class="$store.getters['settings/getBackendSidebarStateByName']('backend_sidebar') ? '' : 'hidden'" class="p-8 h-full flex items-center">
            <div class="rounded-xl bg-[#011128] p-4 w-full text-xs">
                <img class="relative bottom-[50px] block m-auto" :src="$asset('/hkcm/images/HKCMAnalysen.svg', 'public')" />
                <p class="text-center mt-[-50px] text-xxs">
                    <span class="font-bold pb-2 block">{{ $t('discover_all_markets_heading') }}</span
                    >{{ $t('discover_all_markets') }}
                </p>
                <router-link to="/produkte" class="mainBlue-BG px-6 py-2 rounded-xl w-max block m-auto mt-4 hover:scale-105 duration-300">
                    <span class="">{{ $t('all_markets') }}</span>
                </router-link>
            </div>
        </div>
    </div>
</template>
